import { $qs , $qsa } from "./utils/querySelector"
import gsap from "gsap";
import SplitText from "gsap/SplitText";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger, SplitText);

function workWithUs() {

    if($qs('body').classList.contains('page-template-work-with-us')) {
        var pin = $qs('[data-target=js-wwu-pin]');
        var wwu = $qs('[data-target=js-wwu]');
        var col1 = $qsa('[data-target=js-wwu-col-1]');
        var col2 = $qs('[data-target=js-wwu-col-2]');      
        var title = $qs('[data-target=js-wwu-title]');        
        new SplitText(title, {type: "lines", linesClass: "line"});
        var titleLine = $qsa('.line');        
        [...titleLine].forEach((line) => {
            var wrapper = document.createElement('div');
            wrapper.style.overflow = 'hidden';
            line.parentNode.insertBefore(wrapper, line);
            wrapper.appendChild(line);
        })

        if(window.matchMedia('(max-width:768px)').matches) {
            var yValue = 0;
            var xValue = window.innerWidth
        } else {
            var yValue = window.innerHeight
            var xValue = 0
        }
        
        var loadingTL = gsap.timeline({});
        loadingTL.to(title, {
            opacity: 1
        }, "<")
        loadingTL.fromTo(col1, {
            y: yValue,
            x: xValue,
            opacity: 0,
        }, {
            opacity: 1,
            y: 0,
            x: 0,
            ease: "power4.out",
            duration: 2,
        }, ">")
        loadingTL.fromTo(col2, {
            y: -1 * yValue,
            x: -1 * xValue,
            ease: "power4.out",
            duration: 2,
            opacity: 0,
        }, {
            opacity: 1,
            y: 0,
            x: 0,
            ease: "power4.out",
            duration: 2,
        },  "<"),
        loadingTL.to(titleLine, {
            y: 0,
            duration: 0.8,
            ease: "power3.out"
        }, "<+=0.2")


        var scrollTL = gsap.timeline({
            scrollTrigger: {
                start: 'top top',                
                trigger:  pin,
                scrub: true,                                  
            }
        })
        scrollTL.fromTo(col1, {
            y: 0 ,
            x: 0,          
        }, {            
            y: -0.25 * yValue,
            x: 0.25 * xValue,
            ease: "power4.out",
            duration: 2,
        }, ">")
        scrollTL.fromTo(col2, {
            y: 0,
            x: 0,
            ease: "power4.out",
            duration: 2,            
        }, {            
            y: 0.25 * yValue,
            x: -0.25 * xValue,
            ease: "power4.out",
            duration: 2,
        },  "<")
    }

}

export default workWithUs;